module.exports = __webpack_public_path__ + "static/media/safety-job_site.3b629676.jpg";